import { fetchLeaveBalances, fetchLeaveMovements } from '../../services/leaveBalance';
import { fetchAllPaginated } from '../../utils/supabaseQuery';

export default function absencesBalancesHandlers(deps, api) {
  const { session, setLeaveMovements, setProfile, update } = deps;

  async function loadLeaveMovements() {
    const data = await fetchAllPaginated(fetchLeaveMovements());
    setLeaveMovements(data || []);
  }

  // Le solde CP change en base sans passer par l'appli (acceptation, refus, suppression ou
  // modification d'un congé payé, crédit mensuel) : on relit les soldes visibles et le journal après
  // chaque action sur une absence, pour que Équipe, Congés et Mon profil affichent le bon chiffre.
  async function refreshLeaveBalances() {
    const { data, error } = await fetchLeaveBalances();
    if (!error) {
      const balanceById = Object.fromEntries(
        (data || []).map((p) => [p.dev_id || p.id, p.solde_cp]),
      );
      update((s) => ({
        ...s,
        devs: (s.devs || []).map((d) =>
          d.id in balanceById ? { ...d, soldeCp: balanceById[d.id] || 0 } : d,
        ),
      }));
      const own = (data || []).find((p) => p.id === session?.user?.id);
      // Profil inchangé si le solde n'a pas bougé : un nouveau profil relancerait tous les
      // chargements de la vue (useViewDataLoading en dépend).
      if (own)
        setProfile((p) =>
          p && p.solde_cp !== own.solde_cp ? { ...p, solde_cp: own.solde_cp } : p,
        );
    }
    await api.loadLeaveMovements();
  }

  return { loadLeaveMovements, refreshLeaveBalances };
}
